import { 
  Component, 
  OnInit,
  OnChanges,
  Input,
  SimpleChanges, 
  EventEmitter,
  Output,
  Inject
} from '@angular/core';

import { FatNumberStyles } from './models/widget';
import { isNil } from 'lodash-es';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { WorkOrders_ShellService } from './WorkOrders.shell.service';
import { WorkOrders_OperationService } from './WorkOrders.operation.service';
import { WorkOrders_DatasourceService } from './WorkOrders.datasource.index';
import { WorkOrders_FlowService } from './WorkOrders.flow.index';
import { WorkOrders_ReportService } from './WorkOrders.report.index';
import { WorkOrders_LocalizationService } from './WorkOrders.localization.service';
import { WorkOrders_work_order_completed_tasks_count_wdiget_ComponentContextService } from './WorkOrders.work_order_completed_tasks_count_wdiget.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './WorkOrders.frontend.types'
import { $frontendTypes as $types} from './WorkOrders.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'WorkOrders-work_order_completed_tasks_count_wdiget',
  templateUrl: './WorkOrders.work_order_completed_tasks_count_wdiget.component.html'
})
export class WorkOrders_work_order_completed_tasks_count_wdigetComponent extends BaseComponent implements OnInit, OnChanges {
  //#region Outputs
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  inParams: { workOrderId: number } = { workOrderId: null };
  //#region Inputs
  @Input('workOrderId') set $inParams_workOrderId(v: number) {
    this.inParams.workOrderId = v;
  }
  get $inParams_workOrderId(): number {
    return this.inParams.workOrderId;
  }
  //#endregion Inputs

  //#region Variables
  //#endregion  
  private entity: { ActualCount?: number, WorkOrderId?: number };

  value: any;
  styles: FatNumberStyles;
  originalValue: any;
  prefix: string = '';
  suffix: string = '';

  constructor(private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: WorkOrders_ShellService,
private $datasources: WorkOrders_DatasourceService,
private $flows: WorkOrders_FlowService,
private $reports: WorkOrders_ReportService,
private $localization: WorkOrders_LocalizationService,
private $operations: WorkOrders_OperationService,
private $logger: CleanupLoggerService,
private $context: WorkOrders_work_order_completed_tasks_count_wdiget_ComponentContextService,
) { 
    super();

    this.styles = new FatNumberStyles();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.workOrderId)) {
        this.$missingRequiredInParams.push('workOrderId');
      }
  }

  initialized = false;
  $hasDataLoaded = false;

  async $init() {

    await this.$dataLoad();

    this.initialized = true;
  }
  
  async $dataLoad() {
    const $widget = this;
    const $utils = this.$utils;

    const dsParams = {
      workOrderId:  $widget.inParams.workOrderId 
    };

    const data = await this.$datasources.WorkOrders.ds_work_order_completed_tasks_count_widget.get(dsParams);
    if (isNil(data.result)) {
      this.$hasDataLoaded = false;
      this.entity = null;
    } else {
      this.$hasDataLoaded = true;
      this.entity = data.result;
      await this.$dataLoaded();
    }
  }

  async $dataLoaded() {
    const $widget = this;
    const $utils = this.$utils;

    this.value = $utils.isDefined($widget.entity.ActualCount) ? $widget.entity.ActualCount : 0;

    
    this.originalValue = $utils.isDefined($widget.entity.ActualCount) ? $widget.entity.ActualCount : 0;
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  getStyleClass() {
    const valString = isNil(this.value) ? '' : this.value.toString();
    const length = (valString).length;
    if (length === 2) {
      return 'tens';
    }
    if (length === 3) {
      return 'hundreds';
    }
    if (length === 4) {
      return 'thousands';
    }
    if (length === 5) {
      return 'tenThousands';
    }
    if (length === 6) {
      return 'hundredThousands';
    }
    if (length > 6) {
      return 'millions';
    }
    return null;
  }

}
